<template>
  <b-dropdown
    id="list-downloader"
    ref="list-downloader"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
  >
    <template #button-content>
      <McButton
        id="btn-content"
        v-bind="buttonProps"
        variant="secondary"
        :text="$t('global.action.download')"
        icon="icon-outline_download"
        :disabled="disabled"
      />
    </template>
    <b-dropdown-form class="px-3 py-2">
      <p class="mb-3 fw-bolder">{{ $t('global.selectAmountData') }}</p>
      <McRadioButton
        v-for="option in pageOptions"
        name="page_option"
        v-model="selectedPageOption"
        :initialValue="option.key"
        :label="`${option.label} (${option.amount})`"
        :id="option.key"
        :key="option.key"
      />
      <div class="mt-4">
        <button
          v-for="format in formatTypes"
          type="button"
          class="download-btn"
          @click="handleDownload(format.type)"
          :key="format.type"
        >
          <span><img :src="format.icon" :alt="format.type" /></span>
          {{ $t('global.downloadTo') }} {{ format.label }}
        </button>
        <slot name="after-content" :download="handleDownload" />
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'
import McRadioButton from '@/components/McRadioButton'
import formatTypes from './lib/formatTypes'

export default {
  components: {
    McButton,
    McRadioButton,
  },
  props: {
    pageOptions: {
      type: Array,
      required: true,
    },
    fileFormatOptions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['download'],
  data() {
    return {
      selectedPageOption: this.pageOptions[0].key,
    }
  },
  computed: {
    formatTypes() {
      return formatTypes.filter((format) => this.fileFormatOptions.includes(format.type))
    },
  },
  mounted() {
    this.removeBorder()
  },
  methods: {
    handleDownload(format, code = null) {
      this.$emit('download', format, this.selectedPageOption, code)
      this.$refs['list-downloader'].hide(true)
    },
    removeBorder() {
      const element = document.getElementById('list-downloader__BV_toggle_')
      if (element) {
        element.style.border = 'none'
      }
    },
  },
}
</script>

<style scoped lang="scss">
#list-downloader {
  border-color: $black;

  :deep(.btn-secondary) {
    &:hover,
    &:focus,
    &:active {
      opacity: 1 !important;
      border-color: $mep-primary;
    }
  }

  .dropdown-menu {
    width: auto;
  }

  .custom-control {
    margin-bottom: 12px;
    text-wrap: nowrap;
  }

  #btn-content {
    border: none;
  }

  :deep(.download-btn) {
    background-color: white;
    width: 100%;
    border: 1px solid $mep-primary;
    color: $mep-primary;
    font-weight: 600;
    padding: 5px 20px;
    min-width: 200px;
    white-space: nowrap;

    span {
      margin-right: 2px;
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}
</style>
